"use strict";

angular.module("core")
.service("IndustryService", function($resource, $q, appConfig) {
    var cacheQuery = null;
    var cacheFilterQuery = null;

    function executeQuery(extraParams) {
        var params = {
            "depth": 4
        };

        params = angular.extend(params, extraParams);

        var resource = $resource(appConfig.API_SERVER + "/auth/industry/", params, {
            query: {
                method: "get",
                isArray: true,
                ignoreLoadingBar: true
            }
        });
        return resource.query();
    }

    this.query = function() {
        if (cacheQuery === null) {
            cacheQuery = executeQuery();
        }
        return cacheQuery;
    };

    this.queryFilters = function() {
        if (cacheFilterQuery === null) {
            cacheFilterQuery = executeQuery({"exclude_id": 1});
        }
        return cacheFilterQuery;
    };

    this.getIds = function(industries) {
        var industryIds = [];
        angular.forEach(industries, function(value) {
            industryIds.push(value.id);
        });
        return industryIds;
    };

    this.getFilterIdParameter = function(industries) {
        return this.getIds(industries).join(",");
    };

    this.getSelectedIndustries = function(selectedIndustryIds) {
        var deferred = $q.defer();
        this.queryFilters().$promise.then(function(tree) {
            var selectedIndustries = [];
            appendSelectedIndustries(tree, selectedIndustryIds, selectedIndustries, 5);
            deferred.resolve(selectedIndustries);
        }, deferred.reject);
        return deferred.promise;
    };

    function appendSelectedIndustries(tree, selectedIndustryIds, selectedIndustries, depth) {
        if (depth === 0) {
            return;
        }

        angular.forEach(tree, function(industry) {
            if (selectedIndustryIds.indexOf(industry.id + "") >= 0) {
                selectedIndustries.push(industry);
            }

            if (industry.children) {
                appendSelectedIndustries(industry.children, selectedIndustryIds, selectedIndustries, depth - 1);
            }
        });

    }

});



//////////////////
// WEBPACK FOOTER
// ./core/industry/industry.service.js
// module id = 423
// module chunks = 0